import {Pipe, PipeTransform} from "@angular/core";
import {INSURANCE_SECTIONS} from "../_maps/insurance-section";

@Pipe({name: "insuranceSection"})
export class InsuranceSectionPipe implements PipeTransform {
  transform(section: string): string {
    return section && INSURANCE_SECTIONS[section] || '';
  }
}
